export default __webpack_public_path__ + "static/media/newlogo2.1bb67d53.png";